export default {
  activation_error: {
    title: 'There was an error activating your account',
    subtitle: 'Contact support to solve the problem.'
  },
  activating_account: {
    title: 'Wait a moment,',
    subtitle: 'your account is being activated.',
    subtitleDescription: 'At the end of the process, you will be redirected automatically.'
  },
  landing_activation: {
    title: 'Account activation',
    tittle_google: 'Your School already has Google for Education',
    token_label: 'Token: ',
    description: 'Choose one of the following options to activate your account:',
    description_aluzo: 'This allows you to access our platforms and retain your information from past cycles.',
    description_google: 'Activate your account using the institutional email of your school.',
    new_button: 'Create new account',
    existing_button: 'I have an account',
    invalid_token: 'The requested Token is missing or invalid.',
    invalid_token_length: 'The requested Token is too short.',
    activated_token: 'The requested Token is activated.',
    amco_account: 'Use your Amco account',
    login_title: 'If you already have an account enter your information',
    login_with_google: 'Login With Google',
    google_domain_info: 'Your school\'s Google email account has the ending: {domain}',
    google_domain_info_error: 'The Google email account you have provided is not valid. Please use your Google account with termination: {domain}',
    google_user_info_error: 'The email account google {account} that you have provided has already been activated for the year {year}. Use another google account with ending: {domain}',
    invalid_api_version: 'The token you are trying to activate is for a previous cycle, your school admin will handle your access for next year',
    forgot_account: 'Did you forget your password or username?',
    forgot_account_google: 'If you forgot your password, do not remember your institutional email or do not have an institutional account, contact your school administrator.',
    create_account: "You are new? Don't have an account yet?",
    login: 'Login',
    invalid_username_password: 'The username or password is incorrect.',
  },
  creating_account: {
    title: 'Create a new account',
    description: 'Remember that if you already have an Amco account and create a new one, you will lose access to all the information you had created with your original account.',
    create_account: 'Are you sure you need to create a new account?',
    activate: 'Activate',
    back: 'Back',
    title_modal: 'Your school has Google for Education',
    info_modal: 'Activate your account using the institutional email of your school, for this it will be sent to a special activation portal.'
  },
  labels: {
    personal_info: 'Personal information',
    name: 'Name',
    last_name: 'Last name',
    email: 'Email to recovery',
    email_disclaimer: 'The recovery email will help you to access the platform if you forgot how to access.',
    username: 'Username',
    username_disclaimer: 'The username must contain alphanumeric characters. Spaces or special characters are not accepted.',
    password: 'Password',
    password_confirm: 'Password confirmation',
    password_disclaimer: 'Must have at least 8 characters.',
    login_username: 'Username or email'
  },
  errors: {
    invalid_username: 'Invalid username',
    invalid_recovery_email: 'Invalid recovery email',
    invalid_password: 'The passwords are not the same',
    invalid_password_characters: 'Should not have special characters',
    invalid_password_length: 'The password is too short',
    invalid_request: 'The request cannot be processed',
    invalid_token: 'The requested Token is missing or invalid.',
    invalid_token_service: 'The token you are trying to active is for another service, try this link: ',
    invalid_token_expired: 'The token has expired, reach out to your school administrator.',
    invalid_token_expired_aluzo: 'Sorry, the provided token is expired.',
    invalid_token_aluzo: 'Sorry, the provided token is invalid.',
    invalid_email: 'Sorry, the email provided is invalid.'
  },
  information: {
    token: "The token is a unique code that works like a personal key to activate your Amco account.",
    email: "The recovery email will help you access the platform if you have forgotten how to log in.",
    username: "The username must contain only letters (a - z) and numbers (0-9). It does not accept spaces or special characters."
  }
}
